var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 2.50008C1.66675 2.03984 2.03984 1.66675 2.50008 1.66675H9.99662C10.4569 1.66675 10.83 2.03984 10.83 2.50008C10.83 2.96032 10.4569 3.33341 9.99662 3.33341H3.33341V16.6667H10.0001C10.4603 16.6667 10.8334 17.0398 10.8334 17.5001C10.8334 17.9603 10.4603 18.3334 10.0001 18.3334H2.50008C2.03984 18.3334 1.66675 17.9603 1.66675 17.5001V2.50008Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1608 5.66083C13.4863 5.33539 14.0139 5.33539 14.3393 5.66083L18.0893 9.41083C18.4148 9.73626 18.4148 10.2639 18.0893 10.5893L14.3393 14.3393C14.0139 14.6648 13.4863 14.6648 13.1608 14.3393C12.8354 14.0139 12.8354 13.4863 13.1608 13.1608L16.3216 10.0001L13.1608 6.83934C12.8354 6.5139 12.8354 5.98626 13.1608 5.66083Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83325 9.99642C5.83325 9.53618 6.20635 9.16309 6.66659 9.16309H17.4999C17.9602 9.16309 18.3333 9.53618 18.3333 9.99642C18.3333 10.4567 17.9602 10.8298 17.4999 10.8298H6.66659C6.20635 10.8298 5.83325 10.4567 5.83325 9.99642Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c3e0013adf413ed9c9d4d2049a313c55.svg";
export { ForwardRef as ReactComponent };